/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Router, Route } from 'framework/routing';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import EF1CreatePage from 'domain/gpo/externalForm/ef1/create/EF1CreatePage';
import { EXTERNAL_FORM_ID, EXTERNAL_FORMS_PATH } from 'domain/gpo/externalForm/externalFormRoute';

const ExternalFormRouter: Router = () => {
  const { isAuthenticated } = useAuthenticationService();
  const createRoute = `/:${EXTERNAL_FORM_ID}`;

  return (
    <Routes>
      <Route path={createRoute} element={<EF1CreatePage />} />

      <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
    </Routes>
  );
};

ExternalFormRouter.getRouterPath = () => `${EXTERNAL_FORMS_PATH}/*`;

export default ExternalFormRouter;
